import { Label } from 'app/design/icons/label';
import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';
import { theme } from './shared';
import type { PlaceDetails } from './shared';

export function PlaceDiscountBanner({
  onOpen,
  placeDetails,
}: {
  onOpen: () => void;
  placeDetails?: PlaceDetails | null;
}) {
  const { t } = useTranslation();
  const discount = placeDetails?.discount;
  if (!discount?.title) return null;
  return (
    <Pressable onPress={onOpen}>
      <Row
        alignItems="center"
        gap="spacing.general.x1"
        style={{
          backgroundColor: '#FAD4D2',
          paddingHorizontal: theme.spacing['spacing.general.x5'],
          paddingVertical: theme.spacing['spacing.general.x1'],
        }}
      >
        <Label color={theme.colors['text.primary']} width={28} height={28} />
        <Text color="text.primary" variant="bodyBase" fontWeight="600">
          {discount.title}
        </Text>
        {discount.description ? (
          <Text color="text.brand" style={{ textDecorationLine: 'underline' }}>
            {t('discount.learnMore', { ns: 'neighbour-profile' })}
          </Text>
        ) : null}
      </Row>
    </Pressable>
  );
}
